import React, { useEffect, useState } from "react";

function SwipeIndicatorStrip({density = 16}) {
    //const numberOfArrows = 16;
    const initDelay = 3000;
    const animSeqDelay = 25;
    return (
        <div className="swipeIndicatorStrip">
            {[...Array(2)].map((stripObj, stripIndex) => (
            <div className="stripSection" key={stripIndex}>
                {[...Array(density)].map((arrowObj, arrowIndex) => (
                    <div className="stripItem" key={arrowIndex}
                        style={{animationDelay: `${arrowIndex*5}ms`}}
                    ></div>
                ))}
            </div>
            ))}
        </div>
    );
}
export default SwipeIndicatorStrip